import React, { lazy, memo, Suspense, useState } from 'react';
import { YoutubeVideoProps } from './YoutubeVideo.interface';
const ReactPlayer = lazy(() => import('react-player'));

const YoutubeVideo: React.FC<YoutubeVideoProps> = ({
  video_id,
  autoplay,
  videoIsPlaying,
  loop,
  className,
  inView,
}) => {
  const config = {
    youtube: {
      playerVars: {
        showinfo: 0,
        disablekb: 1,
        origin: 'https://www.youtube.com',
      },
    },
  };

  return (
    <>
      {video_id && inView && (
        <div
          className={`w-full h-full ${autoplay && 'pointer-events-none'}`}
          style={{ position: 'relative' }}
        >
          <Suspense
            fallback={<div className="text-white">Loading video...</div>}
          >
            <ReactPlayer
              url={`https://www.youtube.com/watch?v=${video_id}`}
              width="100%"
              height="100%"
              style={{ position: 'absolute', top: 0, left: 0 }}
              config={config}
              playing={autoplay ? true : videoIsPlaying}
              loop={loop}
              muted={autoplay}
              controls={!autoplay}
              className={className}
            />
          </Suspense>
        </div>
      )}
    </>
  );
};

export default YoutubeVideo;
